import {
  ActionOneParam,
  APISignResult,
  FotorResult,
  ICreateFigureTaskParams,
  TEffectClassify,
  TEffectTask,
  TEffectTemplate,
} from "@/types";
import axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
/**做标记 ，后面任务取代前面的*/
const apiCollection: { [key: string]: number } = {};

const axiosInstance = axios.create({
  timeout: 60000,
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "x-app-id": "app-fotor-web",
  },
});

// 请求拦截器
axiosInstance.interceptors.request.use(
  (
    config: InternalAxiosRequestConfig<any> & {
      needRecord?: boolean;
      needRecordNums?: number;
    }
  ) => {
    if (config?.needRecord && config?.url && config?.method) {
      if (!apiCollection[config.url + config?.method]) {
        apiCollection[config.url + config.method] = 1;
      } else {
        apiCollection[config.url + config.method]++;
      }
      config.needRecordNums = apiCollection[config.url + config.method];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    const config: InternalAxiosRequestConfig<any> & {
      needRecord?: boolean;
      needRecordNums?: number;
    } = response.config;
    if (
      config?.needRecord &&
      config?.url &&
      config?.method &&
      config?.needRecordNums
    ) {
      // 说明不是新的
      if (
        config?.needRecordNums !== apiCollection[config.url + config.method]
      ) {
        return Promise.reject("不是最新请求");
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function getUploadUrl(
  fileType = "jpeg"
): Promise<FotorResult<APISignResult>> {
  return axiosInstance
    .get("/api/create/sign", {
      params: {
        mimeType: fileType,
      },
    })
    .then((res) => res.data);
}

export function downloadFile(
  url: string,
  onProgress?: (progress: number) => void
) {
  return axios({
    method: "get",
    url,
    responseType: "blob",
    timeout: 60000,
    onDownloadProgress: (progressEvent) => {
      const total = progressEvent.total || 0;
      const current = progressEvent.loaded || 0;
      const percentCompleted = Math.round((current * 100) / total);
      onProgress?.(percentCompleted);
    },
  });
}

function putFileToOss(
  { contentType, url, file }: any,
  onUploadProgress?: ActionOneParam<number>
) {
  return axios({
    method: "PUT",
    url,
    data: file,
    onUploadProgress: (progressEvent) => {
      const { loaded, total = 100 } = progressEvent;
      onUploadProgress && onUploadProgress(loaded / total);
    },
    withCredentials: false,
  });
}

export function uploadS3File(
  url: string,
  image: File,
  onUploadProgress?: ActionOneParam<number>
) {
  return new Promise((resolve, reject) => {
    putFileToOss(
      {
        contentType: "image/jpeg",
        url: url,
        file: image,
      },
      onUploadProgress
    )
      .then((res) => {
        if (res?.status === 200) {
          resolve(true);
        } else {
          reject();
        }
      })
      .catch(() => {
        reject();
      });
  });
}

export function getClassiftList(): Promise<FotorResult<TEffectClassify[]>> {
  return axiosInstance
    .get("/api/create/action-figure-filter/category")
    .then((res) => res.data);
}

export function getEffectList(
  categoryId?: string
): Promise<FotorResult<TEffectTemplate[]>> {
  return axiosInstance
    .get("/api/create/action-figure-filter/template", {
      needRecord: true,
      params: {
        categoryId: categoryId,
      },
    } as AxiosRequestConfig<any>)
    .then((res) => res.data);
}

export function getEffectTasks(taskId: string): Promise<FotorResult<TEffectTask[]>> {
  return axiosInstance
    .get("/api/create/action-figure-filter/task", {
      params: {
        taskIds: taskId,
      },
    })
    .then((res) => res.data);
}

export function createFigureTask(
  params: ICreateFigureTaskParams
): Promise<FotorResult<TEffectTask[]>> {
  return axiosInstance
    .post("/api/create/action-figure-filter", params)
    .then((res) => res.data);
}
